import React from "react";
import Typewriter from "typewriter-effect";

function Type() {
  return (
    <Typewriter
      options={{
        strings: [
            "Web Developer",
          "Software Developer",
          "MERN Stack Developer",
          "Open Source Contributor",
          "Tech Enthusiast"
        ],
        autoStart: true,
        loop: true,
        deleteSpeed: 200,
      }} 
    />
  );
}

export default Type;